<div
    class="agpr-canvasEmailStyle"
    id="id + '_canvasEmailStyle'"
>
    <div class="agpr-canvasEmailStyle-sectionLabel">
        {{ 'Briefings.emailDesign.header' | localize }}
    </div>

    <div class="agpr-canvasEmailStyle-radioGroup">
        <agpr-radio
            id="id + '_emailDesign_default'"
            [value]="designTypeEnum.DEFAULT"
            label="Briefings.emailDesign.option.default"
            [(ngModel)]="designType"
            (ngModelChange)="designTypeChanged()"
        ></agpr-radio>
        <agpr-radio
            id="id + '_emailDesign_custom'"
            [value]="designTypeEnum.CUSTOM"
            label="Briefings.emailDesign.option.custom"
            [(ngModel)]="designType"
            (ngModelChange)="designTypeChanged()"
        ></agpr-radio>
    </div>

    @if (designType === designTypeEnum.CUSTOM) {
        <div class="agpr-canvasEmailStyle-card">
            <div
                class="agpr-canvasEmailStyle-summary"
                [style.background-color]="style.brandColor"
            >
                <div class="agpr-canvasEmailStyle-imageWrapper">
                    @if (style.brandLogoUrl && !logoLoadError) {
                        <div class="agpr-canvasEmailStyle-logoPlaceholder">
                            <img
                                id="id + '_emailDesign_custom' + '_brandLogo'"
                                class="agpr-canvasEmailStyle-logo"
                                [src]="style.brandLogoUrl"
                                (error)="onLogoLoadError()"
                            />
                        </div>
                    } @else {
                        <div
                            class="agpr-canvasEmailStyle-logoPlaceholder"
                            [style.background-color]="style.brandColor"
                            [style.border-color]="brandTextColor"
                        >
                            <span
                                [style.color]="brandTextColor"
                                id="id + '_emailDesign_custom' + '_brand_placeholderText'"
                            >{{ placeholderText }}</span>
                        </div>
                    }
                    <agpr-content-library-panel
                        [id]="id + '_canvasEmailStyle' + '_logoPicker'"
                        [config]="contentLibrary"
                        [field]="contentLibraryField"
                        [socialTheme]="true"
                        (changes)="updateLogoImage($event)"
                        buttonTooltip="Briefings.emailDesign.previewEmail.dialog.editImage"
                    ></agpr-content-library-panel>
                </div>

                <div class="agpr-canvasEmailStyle-name">
                    @if (isEditingName) {
                        <agpr-text-input
                            [id]="id + '_canvasEmailStyle_nameInput'"
                            class="agpr-canvasEmailStyle-nameInput"
                            [placeholder]="'Briefings.emailDesign.option.custom.brandName.placeholder'"
                            [(ngModel)]="nameInputValue"
                            (blur)="doneEditingName()"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    } @else {
                        <span
                            class="agpr-canvasEmailStyle-nameText"
                            [style.color]="brandTextColor"
                        >
                            {{ style.brandName || ('Briefings.emailDesign.option.custom.brandName.placeholder' | localize) }}
                        </span>
                        <agpr-button
                            [id]="id + '_canvasEmailStyle_summary_editButton'"
                            class="agpr-canvasEmailStyle-summary-editButton"
                            icon="fa-regular fa-duotone fa-pen"
                            [style]="buttonTypesEnum.icon"
                            tooltip="Amplify.fakeBlockType.companyLogo.edit"
                            tooltipPosition="top"
                            (click)="isEditingName = true; nameInputValue = style.brandName;"
                        ></agpr-button>
                    }
                </div>
            </div>

            <div class="agpr-canvasEmailStyle-colorField">
                <label>{{ 'Briefings.emailDesign.option.custom.brandColor' | localize }}</label>
                <agpr-color-picker-field
                    [id]="id + '_canvasEmailStyle_colorPicker'"
                    [ngModel]="style.brandColor"
                    (ngModelChange)="brandColorChanged($event)"
                    [brandId]="brandId"
                    [config]="{
                        showRecentColors: true
                    }"
                ></agpr-color-picker-field>
            </div>
        </div>
    }
</div>
